import { faFrown, faPaperPlane } from '@fortawesome/pro-solid-svg-icons';

/**
 * Component reponible for www#/password-reset
 */
angular.module('gateApp').component('passwordReset', {
  template: require('./password-reset.html').default,
  controller: function (
    $routeParams: ng.route.IRouteParamsService,
    $translate: ng.translate.ITranslateService,
    user,
  ) {
    const $ctrl = this;

    $ctrl.faFrown = faFrown;
    $ctrl.faPaperPlane = faPaperPlane;

    let username = $routeParams.username;

    if (!username) {
      username = $routeParams.email ? $routeParams.email : '';
    }

    $ctrl.request = {
      username: username,
      key: $routeParams.key ? $routeParams.key : '',
    };

    $ctrl.reset = (username, key, password, passwordConfirmation) => {
      $ctrl.error = undefined;
      $ctrl.message = undefined;

      return user
        .passwordReset(username, key, password, passwordConfirmation)
        .then(
          () => {
            $translate('gate.password_reseted').then((message) => {
              $ctrl.message = message;
            });
          },
          (errorMessage) => {
            $ctrl.error = errorMessage;
          },
        );
    };
  },
});
